import type { Plan } from '@/core/domain';
import type { PlanRepository } from '../repositories/plan-repository';

export class UpdatePlanUseCase {
  constructor(private readonly repository: PlanRepository) {}

  async execute(id: string, plan: Partial<Plan>): Promise<Plan> {
    return this.repository.update(id, plan);
  }
}
